export const IN_POSSESSION = 'inPossession';
export const OUT_OF_POSSESSION = 'outOfPossession';
export const MIXED_POSSESSION = 'mixedPossession';
